import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ConfirmUnenrollModalProps from "@/app/interfaces/ConfirmUnenrollModalProps";

const UnenrollModal = ({
  program,
  onClose,
  onConfirm,
}: ConfirmUnenrollModalProps) => {
  const handleConfirm = () => {
    if (program) {
      onClose();
      onConfirm(program);
    }
  };

  return (
    <Dialog
      open={!!program}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, p: 2 },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "#58a6d1",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent sx={{ textAlign: "center", pt: 4 }}>
        <Typography
          sx={{
            fontWeight: 800,
            color: "#333",
            mb: 1,
            letterSpacing: "0.5px",
          }}
        >
          CONFIRM UNENROLL
        </Typography>

        <Box sx={{ px: 2 }}>
          <Typography
            sx={{
              color: "#333",
            }}
          >
            Are you sure you want to unenroll from <br />
            {program?.vendor.programDisplayName}?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 2, gap: 2 }}>
        <Button className="darkBlueButtonOutline" onClick={onClose}>
          NO
        </Button>
        <Button onClick={handleConfirm} className="darkBlueButtonSolid">
          YES
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnenrollModal;
